import template from './login.html';
import controller from './login.controller';
import './login.less';

let loginComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default loginComponent;



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.js